export const appConfig = {
  baseURL: import.meta.env.VITE_BASE_URL ?? 'http://localhost',
  redirectTargetDomain: import.meta.env.VITE_REDIRECT_TARGET_DOMAIN || 'https://talent.staging.rockengroup.com',
  defaultLocale: import.meta.env.VITE_DEFAULT_LOCALE || 'de',
  wsKey: import.meta.env.VITE_WS_PUBLIC_KEY || 'default-pusher-key',
  wsCluster: import.meta.env.VITE_WS_CLUSTER || 'mt1',
  wsProtocol: import.meta.env.VITE_WS_PROTOCOL || 'https',
  wsHost: import.meta.env.VITE_WS_HOST || 'api.main.sandbox.rockengroup.com',
  wsPort: import.meta.env.VITE_WS_PORT || '6002',
  crmUrl: import.meta.env.VITE_CRM_URL || 'http://localhost:3001',
  pdfApiUrl: import.meta.env.VITE_PDF_API_URL || import.meta.env.VITE_BASE_URL || 'http://localhost',
  cmsUrl: import.meta.env.VITE_CMS_URL || 'http://localhost',
  cmsUrlDe: import.meta.env.VITE_CMS_URL_DE || 'http://localhost',
  cmsUrlApplication: import.meta.env.VITE_CMS_URL_APPLICATION || 'http://localhost',
  cmsUrlApplicationDe: import.meta.env.VITE_CMS_URL_APPLICATION_DE || 'http://localhost'
}
